const modalsStoreModule = {
  namespaced: true,
  state: () => ({
    counter: 0,
    openedModals: {},
    globalModals: {},
  }),
  mutations: {
    open(state, { name, modalRef }) {
      state.counter += 1
      state.openedModals[state.counter] = { name, modalRef }
    },
    openGlobalModal(state, { key, component, props, onClosed }) {
      state.globalModals[key] = { component, props, onClosed }
    },
    removeGlobalModal(state, key) {
      delete state.globalModals[key]
    },
    clearGlobalModals(state) {
      state.globalModals = {}
    },
    close(state) {
      delete state.openedModals[state.counter]
      state.counter -= 1
    },
  },
  getters: {
    openedModals: state => state.openedModals,
    globalModals: state => state.globalModals,
    modalCounter: state => state.counter,
  },
}

export default modalsStoreModule
